import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

const ServiceFaq = ({ faqs }) => (
  <section className="bg-orange-50 py-16" data-testid="service-faq">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8" style={{ fontFamily: 'var(--font-serif)' }}>
        Frequently asked questions
      </h2>
      <Accordion type="single" collapsible className="space-y-3">
        {faqs.map((f, i) => (
          <AccordionItem key={f.q} value={`faq-${i}`} className="bg-white rounded-xl border border-gray-200 px-5">
            <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-semibold text-gray-900 hover:no-underline">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-gray-600 leading-relaxed">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export default ServiceFaq;
